import { AuctionStatus } from './AuctionStatus';

const { DRAFT, ENDED, CANCELLED } = AuctionStatus;
export const AuctionWithoutTimerArr = [DRAFT, ENDED, CANCELLED];
